import { CountryIcon, CurrencyIcon, PaymentMethodIcon } from '@components/Icons'
import type { SelectOption } from 'mmfintech-backend-api/types'
import { DropdownOptionRow } from './Input'

/** `formatOptionLabel` for a currency select: the currency's flag before its label. */
export function formatCurrencyOption({ value, label }: SelectOption) {
  return (
    <DropdownOptionRow
      icon={value ? <CurrencyIcon currency={String(value)} size='26px' /> : undefined}
      reserveIcon
      title={label}
    />
  )
}

/** `formatOptionLabel` for a country select: the country's flag before its name. */
export function formatCountryOption({ value, label }: SelectOption) {
  return <DropdownOptionRow icon={<CountryIcon country={String(value)} size='26px' />} title={label} />
}

/** `formatOptionLabel` for a payment method select: the method's kind icon before its name. */
export function formatPaymentMethodOption({ value, label }: SelectOption) {
  return <DropdownOptionRow icon={<PaymentMethodIcon method={String(value)} size={18} />} title={label} />
}
